export function formatLargeNumber(number: number, { decimalPlaces = 0 }: { decimalPlaces?: number } = {}) {
  const formatValue = (value: number, divisor: number, suffix: string) => {
    const result = value / divisor;
    if (decimalPlaces === 0) {
      return Math.floor(result) + suffix;
    }
    // Floor the result to the specified decimal places
    const multiplier = Math.pow(10, decimalPlaces);
    const flooredResult = Math.floor(result * multiplier) / multiplier;
    return flooredResult.toFixed(decimalPlaces).replace(/\.?0+$/, '') + suffix;
  };

  if (number > 0) {
    if (number < 1000) {
      return number + ""; // sub 1000
    } else if (number < 1000000) {
      return formatValue(number, 1000, "K"); // kilo
    } else if (number < 1000000000) {
      return formatValue(number, 1000000, "M"); // mega
    } else {
      return formatValue(number, 1000000000, "B"); // giga
    }
  } else if (number < 0) {
    if (number > -1000) {
      return number + ""; // sub 1000
    } else if (number > -1000000) {
      return formatValue(number, 1000, "K"); // kilo
    } else if (number > -1000000000) {
      return formatValue(number, 1000000, "M"); // mega
    } else {
      return formatValue(number, 1000000000, "B"); // giga
    }
  } else {
    return number;
  }
}
